<ion-content class="min-h-screen bg-gray-50 dark:bg-black">
  <main class="flex flex-col lg:flex-row h-full">
    <!-- Left Side SVG for Large Screens -->
    <div
      class="area hidden lg:flex lg:w-1/3 bg-quickdrive dark:bg-quickdrive justify-center items-center"
    >
      <div class="flex flex-col items-center p-2">
        <span class="text-white text-4xl font-bold text-center w-full">Schneller, smarter, sicherer mit Quick Drive.</span>
        <span class="text-white text-xl mt-4 text-center w-full">
          Das unverzichtbare Tool für effizientes Büro-Management.
        </span>
      </div>
      <ul class="circles">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>
    <div class="flex flex-col justify-center px-6 py-20 lg:px-8 lg:w-2/3">

      <!-- Conditional Rendering of Forms -->
      @if(isSignIn() && !isResetPassword()) {
        <app-auth-form
          class="safe-padding"
          [loading]="loading()"
          (modeChange)="handleChangeMode('register')"
          (submit)="handleSubmit($event)"
          (googleLogin)="handleGoogleLogin()"
          (appleLogin)="handleAppleLogin()"
          (microsoftLogin)="handleMicrosoftLogin()"
          (forgotPassword)="handleChangeMode('resetPassword')"
        ></app-auth-form>
      }

      @if(!isSignIn() && !isResetPassword()) {
        <app-auth-register-form
          class="safe-padding"
          [loading]="loading()"
          (modeChange)="handleChangeMode('signIn')"
          (submit)="handleSubmit($event)"
        ></app-auth-register-form>
      }

      @if(isResetPassword()) {
        <app-auth-forgot-password-form
          class="safe-padding"
          [loading]="loading()"
          (submit)="handleSubmit($event)"
          (modeChange)="handleChangeMode('signIn')"
        ></app-auth-forgot-password-form>
      }
    </div>
  </main>
</ion-content>
